
<template>
    <v-dialog v-model="dialog" width="800px"> 
        <v-card v-if="loading">
            <v-card-title class="justify-center"><v-progress-circular indeterminate color="primary"></v-progress-circular></v-card-title>
            <v-card-title class="justify-center">loading ...</v-card-title>
        </v-card>
        <v-card v-if="!loading">
            <v-card-title class="justify-center">Bookings</v-card-title>
            <v-divider class="mx-6"></v-divider>
            <v-card-text>
                <v-row dense>
                    <v-col cols="2" dense class="font-weight-bold">Booking</v-col>
                    <v-col cols="2" dense class="font-weight-bold">From</v-col>
                    <v-col cols="2" dense class="font-weight-bold">Until</v-col>
                    <v-col cols="2" dense class="font-weight-bold text-right">Purchase</v-col>
                    <v-col cols="2" dense class="font-weight-bold text-right">Sale</v-col>
                    <v-col cols="2" dense class="font-weight-bold text-right">Margin</v-col>
                </v-row>
                <v-row dense><v-col cols="12"><v-divider></v-divider></v-col><v-col cols="12"></v-col></v-row>
                <v-row dense v-for="(huov, i) in huovs" :key="huov.huov_code">
                    <v-col cols="2" dense>{{ huov.huov_code }}</v-col>
                    <v-col cols="2" dense>{{ huov.huov_van_datum }}</v-col>
                    <v-col cols="2" dense>{{ huov.huov_tm_datum }}</v-col>
                    <v-col cols="2" dense class="text-right">{{ huov.inkoop }}</v-col>
                    <v-col cols="2" dense class="text-right">{{ huov.verkoop }}</v-col>
                    <v-col cols="2" dense class="text-right">{{ huov.marge }}</v-col>
                    <v-col cols="12" v-if="i+2===huovs.length"><v-divider></v-divider></v-col><v-col cols="12" v-if="i+1===huovs.length"></v-col>
                </v-row>              
            </v-card-text>
            <v-divider class="mx-4"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="dialog=false">Close</v-btn>
            </v-card-actions>
        </v-card>  
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                loading: true,
                dialog: false,
                huovs: [],
            }  
        },
        methods: {
            openDialog(gebr_encrid, accoLine) {
                this.loading = true;
                this.huovs = [];
                this.showBookings(gebr_encrid, accoLine);
            },
            showBookings(gebr_encrid, accoLine) {
                if (accoLine.huovs.length === 0) {
                    this.getAgentScaleOverviewHuov(gebr_encrid, accoLine);
                } else {
                    this.huovs = accoLine.huovs;
                    this.loading = false;
                    this.dialog = true;
                }
            },
            getAgentScaleOverviewHuov(gebr_encrid, accoLine) {
                this.$axios.post("ares/json/ares/syst/agent/ovrz/getAgentScaleOverviewHuov.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAgentScaleOverviewHuov"
                    },
                    getAgentScaleOverviewHuov: {
                        gebr_encrid: gebr_encrid,
                        hscj_encrid: accoLine.hscj_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.loading = false;
                    } else {
                        accoLine.huovs = res.data.getAgentScaleOverviewHuov;
                        this.huovs = accoLine.huovs;
                        this.loading = false;
                        this.dialog = true;
                    }
                });
            },
        }
    };

</script> 

